const carouselItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20noir%20atmosphere%20with%20dramatic%20shadows%2C%20warm%20golden%20light%20rays%2C%20movie%20theater%20aesthetic%2C%20elegant%20vintage%20cinema%20style%2C%20deep%20crimson%20and%20amber%20tones%2C%20artistic%20composition%2C%20no%20text&width=1000&height=500&seq=carousel-2026-01&orientation=landscape',
    title: '暑期档必看 · 五部口碑黑马',
    desc: '从悬疑到喜剧，从动漫到纪录，极速影视为你精选今夏最值得看的五部口碑佳作，每一部都经过观众验证，高清上线等你来看。',
    tag: '编辑精选',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20home%20theater%20setting%20with%20cinematic%20lighting%2C%20soft%20amber%20glow%2C%20movie%20night%20atmosphere%2C%20elegant%20interior%20with%20cinema%20elements%2C%20no%20text&width=1000&height=500&seq=carousel-2026-02&orientation=landscape',
    title: '周末宅家 · 追剧马拉松指南',
    desc: '精选三部热播剧全集，从都市爱情到古装权谋，极速影视高清流畅不卡顿，一口气看完一季的快乐你值得拥有。',
    tag: '追剧指南',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Sci-fi%20cinematic%20atmosphere%20with%20ethereal%20warm%20lighting%2C%20futuristic%20yet%20elegant%20aesthetic%2C%20golden%20and%20deep%20blue%20tones%2C%20artistic%20composition%2C%20dreamy%20quality%2C%20no%20text&width=1000&height=500&seq=carousel-2026-03&orientation=landscape',
    title: '科幻迷狂喜 · 国产科幻崛起',
    desc: '从《深海密码》到更多国产科幻力作，极速影视为你整理国产科幻片单，见证中国科幻的飞跃进步，高清画质震撼呈现。',
    tag: '类型专场',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Variety%20show%20stage%20with%20warm%20colorful%20lighting%2C%20entertainment%20atmosphere%2C%20golden%20spotlights%2C%20elegant%20theater%20composition%2C%20vibrant%20sophisticated%20style%2C%20no%20text&width=1000&height=500&seq=carousel-2026-04&orientation=landscape',
    title: '综艺狂欢 · 今夏最热节目单',
    desc: '音乐竞演、户外挑战、脱口秀吐槽……极速影视综艺频道为你整理今夏必看综艺清单，笑点密集解压神器一网打尽。',
    tag: '综艺专题',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Documentary%20style%20cinematic%20scene%20with%20warm%20natural%20lighting%2C%20elegant%20composition%2C%20earth%20tones%20with%20golden%20accents%2C%20contemplative%20atmosphere%2C%20no%20text&width=1000&height=500&seq=carousel-2026-05&orientation=landscape',
    title: '纪录之眼 · 真实故事的力量',
    desc: '极速影视纪录片频道精选五部高分纪实作品，从自然探索到人文观察，用真实的镜头语言带你看见更大的世界。',
    tag: '纪录精选',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
            焦点专题
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto leading-relaxed">
            深度专题策划，发现更多精彩影视内容
          </p>
        </div>
        <div className="flex flex-col gap-6">
          {carouselItems.map((item, i) => (
            <article
              key={i}
              className="group flex flex-col md:flex-row bg-background-50 rounded-2xl overflow-hidden cursor-pointer hover:-translate-y-0.5 transition-all"
            >
              <div className="w-full md:w-2/5 aspect-[16/9] md:aspect-auto overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 p-6 md:p-8 flex flex-col justify-center">
                <span className="inline-flex px-2.5 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-md w-fit mb-3 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 mb-3">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
                <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 mt-4 cursor-pointer">
                  浏览专题 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}